export const routes = [
  {
    title: 'Welt',
    icon: ['fas', 'globe-stand'],
    children: [
      { title: 'Weltkarte', icon: ['fal', 'compass'], route: '/karte' },
      { title: 'Datenbank', icon: ['fas', 'book-open'], route: '/welt' },
      { title: 'Bibliothek', icon: ['fas', 'books'], route: '/bibliothek' },
    ],
  },
  {
    title: 'Spielgruppe',
    icon: ['fas', 'dice-d20'],
    children: [
      { title: 'Sitzung', icon: ['far', 'desktop'], route: '/session' },
      { title: 'Kämpfe', icon: ['far', 'swords'], route: '/dashboard' },
      { title: 'Questlog', icon: ['fas', 'exclamation'], route: '/journal' },
      { title: 'Spielabende', icon: ['fas', 'calendar'], route: '/spielabende' },
      { title: 'Handouts', icon: ['fas', 'scroll'], route: '/handouts' },
    ],
  },
  {
    title: 'Charakter',
    icon: ['fas', 'address-card'],
    children: [{ title: 'In Arbeit', icon: ['far', 'construction'], route: '/' }],
  },
];
